module.exports = __webpack_public_path__ + "img/img (16).60bf0b25.jpg";